var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('v-btn',{attrs:{"icon":"","small":"","color":"secondary","href":_vm.link,"target":"_blank"}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-link")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }